const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMclogoForFooter1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-2cbfa6bc-55b4-4c4e-a1fd-571731bdd3f1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.44805 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 14.75524,
    y: 2.6725,
    width: 10.9375,
    height: 19.655,
    style: {
      fill: "#ff5f00",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.44976,12.5c0-3.98743,1.86698-7.53872,4.77427-9.8275-2.12622-1.67382-4.80899-2.6725-7.72493-2.6725C5.59604,0,0,5.59642,0,12.5s5.59604,12.5,12.4991,12.5c2.91594,0,5.59872-.99868,7.72493-2.6725-2.90729-2.28889-4.77427-5.84007-4.77427-9.8275Z",
    style: {
      fill: "#eb001b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.44805,12.5c0,6.90347-5.59604,12.5-12.4991,12.5-2.91594,0-5.59872-.99868-7.72493-2.6725,2.90736-2.28889,4.77424-5.84007,4.77424-9.8275s-1.86687-7.53872-4.77424-9.8275c2.12622-1.67382,4.80899-2.6725,7.72493-2.6725,6.90306,0,12.4991,5.59642,12.4991,12.5Z",
    style: {
      fill: "#f79e1b",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMclogoForFooter1);
export default __webpack_public_path__ + "static/media/mclogo-for-footer1.ae46c12f0b870ae6a8c11dbc0c8cdc44.svg";
export { ForwardRef as ReactComponent };